import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';

/* Zamena za Angular TachoReuseStrategy: ekrani koje je korisnik otvorio ostaju montirani
   (samo sakriveni) pa izabrani vozač, datumi, nesačuvane izmene i canvas prežive navigaciju. */
export default function KeepAlive({ routes }) {
    const { pathname } = useLocation();
    const visited = useRef({});

    const active = routes.find((r) => pathname === r.path || pathname.startsWith(r.path + '/'));
    if (active) visited.current[active.path] = true;

    return (
        <>
            {routes.map((r) => {
                if (!visited.current[r.path]) return null;
                const Comp = r.component;
                const isActive = active && active.path === r.path;
                return (
                    <div key={r.path} className="keep-alive-page" style={{ display: isActive ? 'block' : 'none' }}>
                        <Comp active={isActive} />
                    </div>
                );
            })}
        </>
    );
}
